import styled from '@emotion/styled';

import { mq } from '@/pages/api-documentation/styles/Api.global.styles';

export const StyledMenu = styled.div`
  padding-top: 2rem;

  ul {
    margin: 0;
    padding: 0;

    &.introduction {
      margin-bottom: var(--spacing-small);
    }

    li {
      color: ${(props) => props?.theme?.colors.menuLinks};

      list-style: none;
      font-size: var(--font-size-small);

      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;

        padding: 1rem 1.5rem 1rem 2rem;

        cursor: pointer;
        text-decoration: none;
        color: ${(props) => props?.theme?.colors.menuLinks};

        &.dnb-anchor {
          font-size: inherit;
          line-height: inherit;
          color: inherit;
        }
      }

      span {
        display: none;

        ${mq['large']} {
          display: block;
        }
      }

      &.active {
        background-color: ${(props) => props?.theme?.colors.menuLinksActive};

        a {
          font-weight: var(--font-weight-medium);
        }
      }

      &:hover {
        background-color: ${(props) => props?.theme?.colors.menuLinksHover};
      }

      &.sub {
        padding-left: var(--spacing-large);
      }

      a > div:last-child {
        width: 70%;
      }

      &.header {
        display: block;
        padding: var(--spacing-small) var(--spacing-large);
        text-transform: uppercase;
        color: ${(props) => props?.theme?.colors.menuSecondary};
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
`;
